import { Controller } from "@hotwired/stimulus";
import { drawFrequencyBars } from "@/utilities/visualizer_helpers";

export default class extends Controller {
  static outlets = ["store-audio--recorder"]
  static targets = ["visualizer"]

  activate(event) {
    if (event.type === "recording") {
      this.visualizerTarget.parentElement.classList.remove("hidden");
    }

    const audioContext = new AudioContext();
    const source = audioContext.createMediaStreamSource(this.storeAudioRecorderOutlet.stream);

    this.analyser = audioContext.createAnalyser();
    this.analyser.fftSize = 256;
    source.connect(this.analyser);

    this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);

    const canvas = this.visualizerTarget;
    const canvasContext = canvas.getContext("2d");

    const draw = () => {
      this.analyser.getByteFrequencyData(this.dataArray);
      drawFrequencyBars(canvasContext, canvas, this.dataArray);
      this.animationId = requestAnimationFrame(draw);
    };

    draw();

    this.visualizerTarget.dataset.state = "play";
  }

  freeze() {
    cancelAnimationFrame(this.animationId);
    const canvas = this.visualizerTarget;
    const canvasContext = canvas.getContext("2d");
    canvasContext.clearRect(0, 0, canvas.width, canvas.height);

    this.visualizerTarget.dataset.state = "pause";
  }

  handleRecording(event) {
    if (event.detail.status === "started") {
      this.activate(event)
    } else {
      this.freeze();
    }
  }
}
